"use client";

import { CreatedBy, Notification } from "@/types/notification";
import NotificationItem, {
  NotificationAvatar,
  NotificationWorkspaceLink,
} from "@/components/tailwind/notification/notificationItem";
import { useWorkspaceContext } from "@/contexts/workspaceContext";

export default function NotificationJoin({
  notification,
  handleAccept,
  handleReject,
  responded,
}: {
  notification: Notification;
  handleAccept: (id: string, sentTo: [CreatedBy], workspaceId: string) => void;
  handleReject: (id: string, sentTo: [CreatedBy], workspaceId: string) => void;
  responded: boolean;
}) {
  const { getMemberName } = useWorkspaceContext();
  const displayName = getMemberName(notification.createdBy?.userId) || getMemberName(notification.createdBy?.userEmail) || notification.createdBy?.userName || "System";
  const showActions = !notification.responsed && !responded;

  return (
    <NotificationItem
      icon={<NotificationAvatar name={displayName} userId={notification.createdBy?.userId} email={notification.createdBy?.userEmail} />}
      createdAt={notification.createdAt}
      unread={!notification.read}
      title={displayName}
      message={
        <>
          Requested to join{" "}
          <NotificationWorkspaceLink
            workspaceId={notification.workspaceId}
            workspaceName={notification.workspaceName}
          />
        </>
      }
      actions={
        showActions ? (
          <>
            <button
              type="button"
              onClick={() =>
                handleAccept(
                  notification._id,
                  [notification.createdBy],
                  notification.workspaceId as string
                )
              }
              className="rounded-md border  bg-white px-2.5 py-1 text-[13px] font-medium text-gray-700 shadow-sm transition hover-component disabled:opacity-50 border-component dark:bg-transparent dark:text-gray-200 "
            >
              Approve
            </button>
            <button
              type="button"
              onClick={() =>
                handleReject(
                  notification._id,
                  [notification.createdBy],
                  notification.workspaceId as string
                )
              }
              className="rounded-md border  bg-white px-2.5 py-1 text-[13px] font-medium text-gray-700 shadow-sm transition hover-component disabled:opacity-50 border-component dark:bg-transparent dark:text-gray-200 "
            >
              Deny
            </button>
          </>
        ) : undefined
      }
    />
  );
}
